<script>
import { Chrome } from '@lk77/vue3-color';

export default {
  components: {
    Chrome,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    allowTransparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isPickerOpen: false,
    };
  },
  computed: {
    colorInputName() {
      return `${this.id}Option`;
    },
    transparentInputId() {
      return `${this.id}-transparent`;
    },
    isTransparent() {
      return this.value === 'transparent';
    },
  },
  methods: {
    closeTogglePicker() {
      if (this.isPickerOpen) {
        this.toggleColorPicker();
      }
    },
    toggleColorPicker() {
      this.isPickerOpen = !this.isPickerOpen;
    },
    updateColor(e) {
      this.$emit('update:modelValue', e.hex);
    },
    setColor() {
      this.$emit('update:modelValue', '#7663AB');
    },
    setTransparent() {
      this.$emit('update:modelValue', 'transparent');
    },
  },
};
</script>

<template>
  <div>
    <div v-if="allowTransparent" class="flex mb-2">
      <input
        :id="id"
        type="radio"
        :name="colorInputName"
        :value="false"
        :checked="!isTransparent"
        class="mr-2"
        @input="setColor"
      />
      <label class="mr-2" :for="id">Color</label>
      <input
        :id="transparentInputId"
        type="radio"
        :name="colorInputName"
        :value="true"
        :checked="isTransparent"
        class="mr-2"
        @input="setTransparent"
      />
      <label class="mr-2" :for="transparentInputId">Transparent</label>
    </div>

    <div v-if="!isTransparent" class="colorpicker">
      <div
        class="colorpicker--selected"
        :style="`background-color: ${modelValue}`"
        @click.prevent="toggleColorPicker"
      />
      <Chrome
        v-if="isPickerOpen"
        v-on-clickaway="closeTogglePicker"
        disable-alpha
        :model-value="modelValue"
        class="colorpicker--chrome"
        @update:model-value="updateColor"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.colorpicker {
  position: relative;
}

.colorpicker--selected {
  @apply border border-solid border-n-weak rounded cursor-pointer h-8 w-8 mb-4;
}

.colorpicker--chrome.vc-chrome {
  @apply shadow-lg -mt-2.5 absolute z-[9999] border border-solid border-n-weak rounded;

  ::v-deep {
    input {
      @apply bg-white dark:bg-white;
    }
  }
}
</style>
